import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { getIsUserLogged, getIsDesktopLayout } from '@shared/selectors';
import setSearchedLocation from '@location/actions/setSearchedLocation';
import updateSearchForm from '@location/actions/updateSearchForm';
import onGPSError from '@location/actions/onGPSError';
import getHasSearchedLocation from '@location/selectors/getHasSearchedLocation';
import { getForceFormQuery } from '@location/selectors/getForceFormQuery';
import trackAddressSubmittedStarted from '@location/tracking/actions/trackAddressSubmittedStarted';
import trackConfirmLocationFromMap from '@location/tracking/actions/trackConfirmLocationFromMap';
import trackAddressSubmittedFinished from '@location/tracking/actions/trackAddressSubmittedFinished';
import trackMapClosed from '@location/tracking/actions/trackMapClosed';
import trackModalOpened from '@tracking/actions/trackModalOpened';
import trackModalClosed from '@tracking/actions/trackModalClosed';
import trackMapLoaded from '@location/tracking/actions/trackMapLoaded';
import getSearchForm from '@location/selectors/getSearchForm';
import LocationFlowManager from './LocationFlowManager';

const mapStateToProps = createStructuredSelector({
  isUserLogged: getIsUserLogged,
  hasSearchedLocation: getHasSearchedLocation,
  isDesktopLayout: getIsDesktopLayout,
  forceForm: getForceFormQuery,
  getCurrentSearchForm: getSearchForm,
});

const mapDispatchToProps = {
  setSearchedLocation,
  setAddressInSearchForm: updateSearchForm,
  onGPSError,
  trackAddressSubmittedStarted,
  trackConfirmLocationFromMap,
  trackAddressSubmittedFinished,
  trackMapClosed,
  trackModalOpened,
  trackModalClosed,
  trackMapLoaded,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  LocationFlowManager,
);
